// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Um","option-1":"i_Un","option-2":"i_Uo","option-3":"i_Up","headline":"i_Uq"};